import { Controller } from "stimulus"
import Chart from 'chart.js/auto';

export default class extends Controller {

  static targets = [ "organic", "recyclable", "wast", "total", "months", "period", "measure", "dashboardData" ]

  connect() {
    if (document.body.getAttribute("data-action").includes("new") || document.body.getAttribute("data-action").includes("create") || document.body.getAttribute("data-action").includes("edit") || document.body.getAttribute("data-action").includes("update") || document.body.getAttribute("data-action").includes("edit_account") || document.body.getAttribute("data-action").includes("update_account")) {
      var cleavePhone = new Cleave('.input-phone', {
        phone: true,
        phoneRegionCode: 'br'
      })
    }

    if (document.body.getAttribute("data-action").includes("dashboard")) {
      this.buildChart(this.organicTarget, this.recyclableTarget, this.wastTarget, this.totalTarget, this.monthsTarget)
    }
  }

  // Change Period
  filterDashboard() {
    fetch("/usuarios/dashboard/filtrar", {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        user: {
          period: this.periodTarget.value,
          measure: this.measureTarget.value
        }
      })
    }).then(async (response) => {
      if (response.status == 200) {
        const data = await response.text()
        this.dashboardDataTarget.innerHTML = data
        this.buildChart(this.organicTarget, this.recyclableTarget, this.wastTarget, this.totalTarget, this.monthsTarget)
      } else {
        const data = await response.json()
        console.log("Ocorreu um erro ao filtrar a dashboard...")
      }
    })
  }

  buildChart(organic, recyclable, wast, total, months) {
    var ctx = document.getElementById('chart')
    new Chart(ctx, {
        "type": "line",
        "data": {
          "labels": JSON.parse(months.value),
          "datasets": [
            {
                label: 'Recicláveis',
                data: JSON.parse(recyclable.value),
                fill: false,
                borderColor: '#7FC7A9',
                backgroundColor: "#7FC7A9",
                lineTension: 0.5,
                pointBackgroundColor: "#7FC7A9",
                pointBorderWidth: 1,
                borderWidth: 2
            },
            {
                label: 'Orgânicos',
                data: JSON.parse(organic.value),
                fill: false,
                borderColor: '#90827A',
                backgroundColor: '#90827A',
                lineTension: 0.5,
                pointBackgroundColor: '#90827A',
                pointBorderWidth: 1,
                borderWidth: 2
            },
            {
                label: 'Rejeitos',
                data: JSON.parse(wast.value),
                fill: false,
                borderColor: '#FF9F1C',
                backgroundColor: '#FF9F1C',
                lineTension: 0.5,
                pointBackgroundColor: '#FF9F1C',
                pointBorderWidth: 1,
                borderWidth: 2
            },
            {
              label: 'Total',
              data: JSON.parse(total.value),
              fill: false,
              borderColor: '#ADC97E',
              backgroundColor: '#ADC97E',
              lineTension: 0.5,
              pointBackgroundColor: '#ADC97E',
              pointBorderWidth: 1,
              borderWidth: 2
          }]
        },
        options: {
          interaction: {
            mode: 'index',
            intersect: false,
          },
          maintainAspectRatio: false,
          layout: {
              padding: {
                top: 60
              }
          },
          scales: {
            x: {
              title: {
                display: true,
                text: "Período"
              }
            },
            y: {
              title: {
                display: true,
                text: "Total coletado"
              }
            },
          },
          plugins: {
              legend: {
                  display: true,
                  position: "bottom",
                  labels: {
                      color: '#1F2121',
                      padding: 40,
                  }
              },
              // tooltip: {
              //     callbacks: {
              //         footer: 'footer',
              //     }
              // }
          }
        }
    });
  }
}
